var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamaskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_259_3396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0511 6.44763L20.124 6.47133L18.381 10.6701L12.0511 6.44763Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.381 10.6701L13.8769 10.6603L12.0511 6.44763L18.381 10.6701Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6911 2.13855L18.381 10.6702L20.1239 6.47134L29.6911 2.13855Z",
    fill: "#E17719",
    stroke: "#E17719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8769 10.6603L2.54395 2.03766L12.0511 6.44762L13.8769 10.6603Z",
    fill: "#E47719",
    stroke: "#E47719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1132 14.3477L30.521 11.7902L30.2492 12.9892L25.1132 14.3477Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.078 14.4296L25.1132 14.3477L30.2492 12.9891L30.078 14.4296Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3651 16.5137L22.9113 14.7238L25.1131 14.3477L29.3651 16.5137Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.078 14.4296L29.3652 16.5137L25.1132 14.3477L30.078 14.4296Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05183 14.3201L1.90954 12.9388L1.63452 11.7327L7.05183 14.3201Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5209 11.7902L25.1131 14.3477L24.8905 7.79437L30.5209 11.7902Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8905 7.79437L25.1131 14.3477L22.9113 14.7238L24.8905 7.79437Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.08423 14.3872L1.90955 12.9388L7.05184 14.3201L2.08423 14.3872Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.80286 16.4833L7.05181 14.3201L9.29359 14.7039L2.80286 16.4833Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.08411 14.3872L7.05172 14.3201L2.80276 16.4833L2.08411 14.3872Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33412 7.74695L7.05183 14.3201L1.63452 11.7327L7.33412 7.74695Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29366 14.7039L7.05188 14.3201L7.33417 7.74695L9.29366 14.7039Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8087 27.0955L21.1106 27.1378L22.8085 27.9989L20.8087 27.0955Z",
    fill: "#E17719",
    stroke: "#E17719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45398 28.0111L11.0951 27.1454L11.3496 27.1026L9.45398 28.0111Z",
    fill: "#E17719",
    stroke: "#E17719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1915 12.2208L30.2491 12.9892L30.5209 11.7902L31.1915 12.2208Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7755 23.4642L30.0267 30.7313L22.8085 27.9989L31.7755 23.4642Z",
    fill: "#E47719",
    stroke: "#E47719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9113 14.7238L18.381 10.6702L24.8905 7.79437L22.9113 14.7238Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.078 14.4296L30.2492 12.9891L31.0101 13.5124L30.078 14.4296Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8905 7.79437L31.342 6.77161L30.5209 11.7902L24.8905 7.79437Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33411 7.74695L13.8769 10.6603L9.2936 14.7039L7.33411 7.74695Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.963013 12.1629L1.63447 11.7327L1.90949 12.9388L0.963013 12.1629Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45394 28.0111L2.09263 30.7703L0.341187 23.4673L9.45394 28.0111Z",
    fill: "#E47719",
    stroke: "#E47719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3651 16.5137L30.0779 14.4296L30.7006 14.8279L29.3651 16.5137Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.08414 14.3872L1.14771 13.4622L1.90946 12.9388L2.08414 14.3872Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.63443 11.7327L0.83606 6.68353L7.33403 7.74696L1.63443 11.7327Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9435 16.9275L29.3652 16.5137L31.7754 23.4642L24.9435 16.9275Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.80284 16.4833L1.46082 14.7856L2.08418 14.3871L2.80284 16.4833Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8085 27.999L26.0306 22.5577L31.7755 23.4643L22.8085 27.999Z",
    fill: "#E47719",
    stroke: "#E47719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9435 16.9275L31.7754 23.4642L26.0306 22.5577L24.9435 16.9275Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34321 16.9087L0.341187 23.4673L2.80284 16.4833L7.34321 16.9087Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3651 16.5137L24.9434 16.9275L22.9113 14.7238L29.3651 16.5137Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.80286 16.4832L9.29359 14.7039L7.34323 16.9086L2.80286 16.4832Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.341187 23.4673L6.25495 22.5564L9.45394 28.0111L0.341187 23.4673Z",
    fill: "#E47719",
    stroke: "#E47719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25495 22.5564L0.341187 23.4673L7.34321 16.9086L6.25495 22.5564Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9113 14.7238L24.9435 16.9275L18.0552 16.9402L22.9113 14.7238Z",
    fill: "#E47719",
    stroke: "#E47719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0552 16.9402L18.3811 10.6702L22.9113 14.7238L18.0552 16.9402Z",
    fill: "#E47719",
    stroke: "#E47719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29358 14.7038L13.8769 10.6603L14.2942 16.9361L9.29358 14.7038Z",
    fill: "#E47719",
    stroke: "#E47719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2942 16.9361L7.34326 16.9086L9.29362 14.7039L14.2942 16.9361Z",
    fill: "#E47719",
    stroke: "#E47719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6911 2.13855L31.342 6.77161L24.8905 7.79437L29.6911 2.13855Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8905 7.79437L18.381 10.6702L29.6911 2.13855L24.8905 7.79437Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.54395 2.03766L13.8769 10.6603L7.33408 7.74691L2.54395 2.03766Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33403 7.74691L0.83606 6.68349L2.54389 2.03766L7.33403 7.74691Z",
    fill: "#773900",
    stroke: "#773900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8768 10.6603L18.381 10.6701L18.0551 16.9401L13.8768 10.6603Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0551 16.9401L14.2941 16.9361L13.8768 10.6603L18.0551 16.9401Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8085 27.9989L22.161 22.3528L26.0307 22.5576L22.8085 27.9989Z",
    fill: "#CD6200",
    stroke: "#CD6200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.454 28.011L6.255 22.5564L10.1797 22.3516L9.454 28.011Z",
    fill: "#CD6200",
    stroke: "#CD6200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0552 16.9402L24.9435 16.9275L22.2118 19.5756L18.0552 16.9402Z",
    fill: "#CD6200",
    stroke: "#CD6200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9436 16.9275L22.161 22.3529L22.2119 19.5756L24.9436 16.9275Z",
    fill: "#E47424",
    stroke: "#E47424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0307 22.5577L22.161 22.3529L24.9436 16.9275L26.0307 22.5577Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1158 19.5683L7.34326 16.9086L14.2942 16.9361L10.1158 19.5683Z",
    fill: "#CD6200",
    stroke: "#CD6200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34326 16.9086L10.1158 19.5683L10.1797 22.3516L7.34326 16.9086Z",
    fill: "#E47424",
    stroke: "#E47424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.34327 16.9086L10.1797 22.3516L6.255 22.5564L7.34327 16.9086Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9313 28.1496L22.8084 27.999L21.4552 28.7615L18.9313 28.1496Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8654 28.7725L9.45398 28.011L13.5752 28.1545L10.8654 28.7725Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2118 19.5756L19.7285 18.4115L18.0552 16.9402L22.2118 19.5756Z",
    fill: "#CD6200",
    stroke: "#CD6200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2941 16.9361L12.6118 18.4057L10.1157 19.5683L14.2941 16.9361Z",
    fill: "#CD6200",
    stroke: "#CD6200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9776 26.569L22.8084 27.999L18.9313 28.1496L18.9776 26.569Z",
    fill: "#D6C2B2",
    stroke: "#D6C2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8084 27.999L18.9776 26.569L18.6277 23.6596L22.8084 27.999Z",
    fill: "#D6C2B2",
    stroke: "#D6C2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6277 23.6596L22.1609 22.3528L22.8084 27.9989L18.6277 23.6596Z",
    fill: "#E47719",
    stroke: "#E47719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7252 20.4067L19.7284 18.4114L22.2117 19.5755L18.7252 20.4067Z",
    fill: "#243343",
    stroke: "#243343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1609 22.3529L18.7252 20.4067L22.2117 19.5756L22.1609 22.3529Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5747 26.5725L13.5752 28.1545L9.45398 28.011L13.5747 26.5725Z",
    fill: "#D6C2B2",
    stroke: "#D6C2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45398 28.0111L13.9305 23.6602L13.5747 26.5726L9.45398 28.0111Z",
    fill: "#D6C2B2",
    stroke: "#D6C2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9305 23.6602L9.45398 28.011L10.1797 22.3516L13.9305 23.6602Z",
    fill: "#E47719",
    stroke: "#E47719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6403 20.4044L10.1157 19.5683L12.6118 18.4057L13.6403 20.4044Z",
    fill: "#243343",
    stroke: "#243343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1797 22.3516L10.1157 19.5683L13.6403 20.4044L10.1797 22.3516Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7285 18.4115L18.7253 20.4068L18.0552 16.9402L19.7285 18.4115Z",
    fill: "#CD6200",
    stroke: "#CD6200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6118 18.4057L14.2942 16.9361L13.6404 20.4044L12.6118 18.4057Z",
    fill: "#CD6200",
    stroke: "#CD6200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7254 20.4068L17.9257 18.9164L18.0552 16.9402L18.7254 20.4068Z",
    fill: "#E17719",
    stroke: "#E17719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.46 18.9139L14.2941 16.9361L18.055 16.9401L14.46 18.9139Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0551 16.9402L17.9255 18.9164L14.4601 18.9139L18.0551 16.9402Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6404 20.4044L14.2942 16.9361L14.4602 18.9139L13.6404 20.4044Z",
    fill: "#E47424",
    stroke: "#E47424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4554 28.7615L18.7056 29.3223L18.9314 28.1495L21.4554 28.7615Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5752 28.1545L13.8126 29.3278L10.8654 28.7725L13.5752 28.1545Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7253 20.4067L22.1609 22.3528L18.6277 23.6595L18.7253 20.4067Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9305 23.6602L10.1797 22.3516L13.6403 20.4044L13.9305 23.6602Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9257 18.9164L18.7254 20.4067L18.0213 23.2364L17.9257 18.9164Z",
    fill: "#E47424",
    stroke: "#E47424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6277 23.6595L18.0212 23.2363L18.7253 20.4067L18.6277 23.6595Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4602 18.9139L14.5375 23.2365L13.6404 20.4044L14.4602 18.9139Z",
    fill: "#E47424",
    stroke: "#E47424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6404 20.4044L14.5375 23.2365L13.9305 23.6602L13.6404 20.4044Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4601 18.9139L17.9255 18.9164L18.0212 23.2363L14.4601 18.9139Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0212 23.2363L14.5374 23.2365L14.4601 18.9139L18.0212 23.2363Z",
    fill: "#F78419",
    stroke: "#F78419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9784 26.569L18.9319 28.1496L18.7056 29.3223L18.9784 26.569Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8132 29.3278L13.5752 28.1545L13.5747 26.5725L13.8132 29.3278Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6742 26.1045L18.7055 29.3223L13.8126 29.3279L18.6742 26.1045Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7055 29.3223L18.6742 26.1045L18.9784 26.569L18.7055 29.3223Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5747 26.5725L13.9012 26.1072L13.8132 29.3278L13.5747 26.5725Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8126 29.3279L13.9004 26.1072L18.6742 26.1045L13.8126 29.3279Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6277 23.6596L18.9785 26.569L18.6743 26.1045L18.6277 23.6596Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9012 26.1072L13.5747 26.5726L13.9313 23.6602L13.9012 26.1072Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.077 23.4752L18.0212 23.2364L18.6277 23.6596L18.077 23.4752Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5261 23.4755L14.5375 23.2366L18.0213 23.2364L14.5261 23.4755Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0213 23.2364L18.0771 23.4752L14.5261 23.4755L18.0213 23.2364Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9305 23.6602L14.5376 23.2366L14.5262 23.4755L13.9305 23.6602Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6748 26.1045L18.4656 23.9142L18.6281 23.6596L18.6748 26.1045Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6277 23.6596L18.4656 23.9142L18.077 23.4752L18.6277 23.6596Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9305 23.6602L14.1379 23.915L13.9004 26.1072L13.9305 23.6602Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5262 23.4755L14.1374 23.915L13.9305 23.6602L14.5262 23.4755Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1373 23.915L18.4655 23.9142L18.6742 26.1045L14.1373 23.915Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6742 26.1045L13.9004 26.1072L14.1373 23.915L18.6742 26.1045Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.077 23.4752L18.4655 23.9142L14.1373 23.915L18.077 23.4752Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1373 23.915L14.5261 23.4755L18.077 23.4752L14.1373 23.915Z",
    fill: "black",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_259_3396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamaskIcon);
export default __webpack_public_path__ + "static/media/metamask-icon.07406a07f1659f219f22842b943ad53d.svg";
export { ForwardRef as ReactComponent };